import React from 'react';
import { Loader } from 'semantic-ui-react';

// Global Components
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import ErrorGate from 'components/ErrorGate';
// @ts-ignore
import InitialDataLoadedErrorGate from 'components/InitialDataLoadedErrorGate';
// @ts-ignore
import LoadingGate from 'components/LoadingGate';
import CurrentMyTimesheetIsEditable from 'components/CurrentMyTimesheetIsEditable';
// @ts-ignore
import PageWrapper from 'components/PageWrapper';

const NAMESPACE = 'MY_TIMESHEET_ENTRIES_LOAD';

interface Props {
    children: React.ReactElement;
}

export class MyTimesheetLoadingGate extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { children } = this.props;
        return (
            <ErrorBoundary
                namespace="MyTimesheetLoadingGate"
                FallbackComponent={<ErrorBoundaryAlert />}
            >
                <ErrorGate namespace={NAMESPACE}>
                    <CurrentMyTimesheetIsEditable
                        FallbackComponent={
                            <LoadingGate
                                namespace={NAMESPACE}
                                LoadingComponent={
                                    <PageWrapper>
                                        <Loader active inline="centered" />
                                    </PageWrapper>
                                }
                            >
                                {children}
                            </LoadingGate>
                        }
                    >
                        <InitialDataLoadedErrorGate
                            namespace={NAMESPACE}
                            LoadingComponent={
                                <PageWrapper>
                                    <Loader active inline="centered" />
                                </PageWrapper>
                            }
                        >
                            {children}
                        </InitialDataLoadedErrorGate>
                    </CurrentMyTimesheetIsEditable>
                </ErrorGate>
            </ErrorBoundary>
        );
    }
}

export default MyTimesheetLoadingGate;
